import { put, takeLatest, call } from "redux-saga/effects";
import {
  ONBOARD_VENDOR_INFO_ACTION,
  ONBOARD_VENDOR_INFO_LOADING,
  ONBOARD_VENDOR_INFO_SUCCESS,
  ONBOARD_VENDOR_INFO_ERROR,
  ONBOARD_VENDOR_VERIFY_ACTION,
  ONBOARD_VENDOR_VERIFY_LOADING,
  ONBOARD_VENDOR_VERIFY_SUCCESS,
  ONBOARD_VENDOR_VERIFY_ERROR,
} from "./types";
import Api from "./api";
import { Constants } from "../../lib/constant";

function* onBoardVendorInfoSaga(data) {
  yield put({ type: ONBOARD_VENDOR_INFO_LOADING });
  try {
    let res = yield call(Api.onBoardVendorInfo, data.vid, data.token);
    if (res.message) {
      yield put({ type: ONBOARD_VENDOR_INFO_ERROR, payload: res.message });
    } else if (res && res.data) {
      yield put({ type: ONBOARD_VENDOR_INFO_SUCCESS, payload: res.data });
    } else {
      yield put({
        type: ONBOARD_VENDOR_INFO_ERROR,
        payload: [Constants.ERROR.INTERNAL_SERVER],
      });
    }
  } catch (error) {
    yield put({ type: ONBOARD_VENDOR_INFO_ERROR, payload: error.message });
  }
}

function* onBoardVendorVerifySaga(data) {
  yield put({ type: ONBOARD_VENDOR_VERIFY_LOADING });
  try {
    let res = yield call(Api.onBoardVendorVerify, data.payload);

    if (res && res.message) {
      yield put({ type: ONBOARD_VENDOR_VERIFY_ERROR, payload: res.message });
    } else if (res && res.data) {
      yield put({ type: ONBOARD_VENDOR_VERIFY_SUCCESS, payload: res.data });
    } else {
      yield put({
        type: ONBOARD_VENDOR_VERIFY_ERROR,
        payload: [Constants.ERROR.INTERNAL_SERVER],
      });
    }
  } catch (error) {
    yield put({ type: ONBOARD_VENDOR_VERIFY_ERROR, payload: error.message });
  }
}

function* watchOnboardVendorAsync() {
  yield takeLatest(ONBOARD_VENDOR_INFO_ACTION, onBoardVendorInfoSaga);
  yield takeLatest(ONBOARD_VENDOR_VERIFY_ACTION, onBoardVendorVerifySaga);
}

export default watchOnboardVendorAsync;
